import React from 'react';
import Header from '../Header/index';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../Pages/Admin/Sidebar/Sidebar';

export function AdminLayout(props) {



    return (
        <>
            
            <main style={{ minHeight: "80vh", display: "flex" }}>
                <Sidebar/>
                <Outlet />
                
            </main>
            
        </>
    );
}


